module.exports = __webpack_public_path__ + "img/color_picker.ca78e953.svg";